import { useCallback, useState } from 'react';

import isRecordingsSeasonsResponse from 'store/details/utils/isRecordingsSeasonsResponse.ts';
import { RecordingsSeasonsResponse } from 'store/railsBuilder/reducer.types.ts';

import { noSeasonName } from '../constants.ts';
import requestRecordingSeasons from '../utils/requestRecordingSeasons.ts';

function useRecordingSeasons() {
    const [recordingSeasons, setRecordingSeasons] = useState<
        RecordingsSeasonsResponse['seasons']
    >([]);

    const handleLoadRecordingSeasons = useCallback(
        async (_seriesId: string) => {
            const recordingsSeasonsResponse = await requestRecordingSeasons(
                _seriesId,
            );

            if (isRecordingsSeasonsResponse(recordingsSeasonsResponse)) {
                const {
                    data: { seasons, totalEpisodes },
                } = recordingsSeasonsResponse;
                const episodesWithSeason = seasons.reduce((amount, season) => {
                    return amount + season.totalEpisodes;
                }, 0);

                if (episodesWithSeason < totalEpisodes) {
                    seasons.push({
                        seasonNumber: noSeasonName,
                        seasonId: noSeasonName,
                        totalEpisodes: totalEpisodes - episodesWithSeason,
                    });
                }

                setRecordingSeasons(seasons);

                return seasons;
            }

            return [];
        },
        [],
    );

    return {
        seasons: recordingSeasons,
        onLoadSeasons: handleLoadRecordingSeasons,
    };
}

export default useRecordingSeasons;
